import React, { useState } from "react";
import closeIcon from "../../../assets/Icon.svg";
import successIcon from "../../../assets/Light.png";
import "./second-success.css";

const SecondSuccess = ({ title, text, isModalOpen, handleModalOpen, buttonText, onBtnClick }) => {
  if (!isModalOpen) return <></>;
  return (
    <div className="modal-container">
      <div className="success-container">
        <button
          style={{ marginTop: -10 }}
          onClick={() => handleModalOpen(false)}
          className="close-button"
        >
          <img src={closeIcon} alt="close-icon" />
        </button>
        <div className="success-title">{title}</div>
        <div className="success-button">
          <img src={successIcon} alt="success-icon" />
        </div>
        <div className="success-text">
          <p style={{ width: "80%" }}>{text}</p>
        </div>
        <button
          type="button"
          onClick={() => {
            onBtnClick && onBtnClick();
          }}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default SecondSuccess;
